import { jsx as _jsx } from "react/jsx-runtime";
import { Locale } from 'signup-ui-lego-core/constants/Locale';
import { getApplicationLocale } from '../i18n/LocaleUtils';
import { Data } from '../signup-data/DATA';
import { useSignupData } from '../signup-data/useSignupData';
import { StepSubtitle } from './StepSubtitle';
import { useEffect, useState } from 'react';
export const NameSubtitle = ({
  translation
}) => {
  const [canRenderNameSubtitle, setCanRenderNameSubtitle] = useState(null);
  const locale = getApplicationLocale();
  const isJapanese = locale === Locale.ja;
  const {
    data: firstName
  } = useSignupData(Data.FirstName);
  const {
    data: lastName
  } = useSignupData(Data.LastName);
  const name = isJapanese ? lastName : firstName;
  useEffect(() => {
    if (canRenderNameSubtitle === null) {
      setCanRenderNameSubtitle(typeof name === 'string' && name !== '');
    }
  }, [name, canRenderNameSubtitle]);

  if (canRenderNameSubtitle) {
    return /*#__PURE__*/_jsx(StepSubtitle, {
      message: translation,
      messageOptions: {
        name
      }
    });
  }

  return null;
};